<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-list title="Personal" resource="personal" primaryKey="idpersonal" :records="records" :meta="meta"
        :columns="columns" :readonly="readonly" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CardList from "@/components/Cards/CardList.vue";
import PersonalService from "@/services/personal.service";
import { personal } from "@/models/personal";

export default {
  components: {
    CardList,
  },

  data() {
    return {
      records: null,
      meta: {},
      columns: personal.filter(column => column.showOnList)
    }
  },

  computed: {
    ...mapState({
      userInfo: state => state.auth.user
    }),
    readonly() {
      const roles = this.userInfo?.roles || [];
      return !roles.includes('admin') && !roles.includes('personal');
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        PersonalService.list(this.$route.query)
          .then((data) => {
            this.records = data.records;
            this.meta = data.meta;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },
};
</script>
